import { CSSObject } from 'styled-components';

const browser = {
  safari: (css: CSSObject) => ({
    [`@media not all and (min-resolution:.001dpcm)`]: css,
  }),
};

export default browser;
